'use client';

import { HStack, IconButton } from '@chakra-ui/react';
import { Eraser, Pencil, Undo2 } from 'lucide-react';
import type { PreviewAnnotationController } from './usePreviewAnnotation';

export function PreviewAnnotationToolbar({
  annotation,
  disabled = false,
}: {
  annotation: PreviewAnnotationController;
  disabled?: boolean;
}) {
  return (
    <HStack gap="0.5" role="group" aria-label="Preview drawing tools">
      <IconButton
        aria-label="Pencil"
        title={annotation.active ? 'Finish drawing' : 'Draw on preview'}
        aria-pressed={annotation.active}
        variant={annotation.active ? 'subtle' : 'ghost'}
        colorPalette={annotation.active ? 'red' : undefined}
        size="sm"
        disabled={disabled && !annotation.active}
        onClick={annotation.toggle}
      >
        <Pencil size={16} />
      </IconButton>
      {annotation.active ? (
        <>
          <IconButton
            aria-label="Undo drawing"
            title="Undo drawing"
            size="sm"
            variant="ghost"
            disabled={!annotation.strokes.length}
            onClick={annotation.undo}
          >
            <Undo2 size={16} />
          </IconButton>
          <IconButton
            aria-label="Clear drawing"
            title="Clear drawing"
            size="sm"
            variant="ghost"
            disabled={!annotation.strokes.length}
            onClick={annotation.clear}
          >
            <Eraser size={16} />
          </IconButton>
        </>
      ) : null}
    </HStack>
  );
}
